import React, { useState, useEffect } from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { Icon } from "semantic-ui-react";

const containerStyle = {
  width: '100%',
  height: '400px',
};

const defaultCenter = { lat: 20.5937, lng: 78.9629 }; // Center of India

const ShippingLocation = ({ setCurrrentLocation, latitude, longitude }) => {
  const [location, setLocation] = useState(defaultCenter);
  const [address, setAddress] = useState('');
  const [mapRef, setMapRef] = useState(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyAgQu2KaS6Y2SIFDc7L23CoaGEagD1yaY0",
    libraries: ['places'],
  });

  // Get address from coordinates
  const getAddress = (lat, lng) => {
    if (!window.google) return;

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === 'OK' && results[0]) {
        setAddress(results[0].formatted_address);
      } else {
        setAddress('Address not found');
      }
    });
  };

  const convertIntoNumber = (value, type) => {
    const num = parseFloat(value);
    if (!isNaN(num)) return num;
    return type === "lat" ? 20.5937 : 78.9629;
  }

  // Called when marker is dragged
  const handleMarkerDragEnd = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    setLocation({ lat, lng });
    setCurrrentLocation({ lat, lng })
    getAddress(lat, lng);
  };

  // Get user's current location
  const handleGetCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          setCurrrentLocation({ lat, lng })
          setLocation({ lat, lng });
          getAddress(lat, lng);
        },
        (err) => {
          alert("Permission denied or unavailable");
        }
      );
    } else {
      alert('Geolocation is not supported by your browser');
    }
  };

  useEffect(() => {
    if (!latitude || !longitude) {
      handleGetCurrentLocation();
    }
    if (isLoaded && location) {
      setLocation({ lat: location.lat, lng: location.lng });
      setCurrrentLocation({ lat: location.lat, lng: location.lng })
      getAddress(location.lat, location.lng);
    }
  }, [isLoaded]);

  if (!isLoaded) return <div>Loading...</div>;

  return (
    <div> 
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={location}
        zoom={15}
        onLoad={(map) => setMapRef(map)}
      >
        <Marker
          position={location}
          draggable={true}
          onDragEnd={handleMarkerDragEnd}
        />
      </GoogleMap>
      <div onClick={handleGetCurrentLocation} style={{ display: "flex", cursor: "pointer" }}>
        <Icon inverted style={{ color: "#5e84f0" }} name='dot circle' />
        <b style={{ marginLeft: 10, color: "#5e84f0" }}>Get Your Current Location</b>
      </div>
    </div>
  );
};

export default ShippingLocation;
